module.exports = __webpack_public_path__ + "static/media/logistic.15e53a2d.svg";